/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TicketsRouteImport } from './routes/tickets'
import { Route as SesionesRouteImport } from './routes/sesiones'
import { Route as DaysOffRouteImport } from './routes/days-off'
import { Route as CrmRouteImport } from './routes/crm'
import { Route as CalendarRouteImport } from './routes/calendar'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as IndexRouteImport } from './routes/index'
import { Route as TeamIndexRouteImport } from './routes/team.index'
import { Route as StandupsIndexRouteImport } from './routes/standups.index'
import { Route as ProjectsIndexRouteImport } from './routes/projects.index'
import { Route as EvaluationsIndexRouteImport } from './routes/evaluations.index'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as StandupsNewRouteImport } from './routes/standups.new'
import { Route as StandupsStandupIdRouteImport } from './routes/standups.$standupId'
import { Route as ProjectsNewRouteImport } from './routes/projects.new'
import { Route as EvaluationsQuestionnairesRouteImport } from './routes/evaluations.questionnaires'
import { Route as EvaluationsKpisRouteImport } from './routes/evaluations.kpis'
import { Route as EvaluationsHistoryRouteImport } from './routes/evaluations.history'
import { Route as EvaluationsDashboardRouteImport } from './routes/evaluations.dashboard'
import { Route as EvaluationsAssessmentsRouteImport } from './routes/evaluations.assessments'
import { Route as EvaluationsIdRouteImport } from './routes/evaluations.$id'
import { Route as AdminUsersRouteImport } from './routes/admin.users'
import { Route as AdminSyncRouteImport } from './routes/admin.sync'
import { Route as AdminQuestionnairesRouteImport } from './routes/admin.questionnaires'
import { Route as AdminProjectCategoriesRouteImport } from './routes/admin.project-categories'
import { Route as AdminKpiDefinitionsRouteImport } from './routes/admin.kpi-definitions'
import { Route as AdminGoogleCalendarSyncRouteImport } from './routes/admin.google-calendar-sync'
import { Route as AdminEvaluationsConfigRouteImport } from './routes/admin.evaluations-config'
import { Route as AdminDaysOffRouteImport } from './routes/admin.days-off'
import { Route as AdminClientsRouteImport } from './routes/admin.clients'
import { Route as AdminCalendarEventsRouteImport } from './routes/admin.calendar-events'
import { Route as AdminAssessmentsRouteImport } from './routes/admin.assessments'
import { Route as TeamUserIdIndexRouteImport } from './routes/team.$userId.index'
import { Route as ProjectsProjectIdIndexRouteImport } from './routes/projects.$projectId.index'
import { Route as TeamUserIdTicketsRouteImport } from './routes/team.$userId.tickets'
import { Route as ProjectsProjectIdIssuesRouteImport } from './routes/projects.$projectId.issues'
import { Route as ProjectsProjectIdEvaluationsConfigRouteImport } from './routes/projects.$projectId.evaluations-config'
import { Route as ProjectsProjectIdEditRouteImport } from './routes/projects.$projectId.edit'
import { Route as EventsEventIdSessionsRouteImport } from './routes/events.$eventId.sessions'

const TicketsRoute = TicketsRouteImport.update({
  id: '/tickets',
  path: '/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const SesionesRoute = SesionesRouteImport.update({
  id: '/sesiones',
  path: '/sesiones',
  getParentRoute: () => rootRouteImport,
} as any)
const DaysOffRoute = DaysOffRouteImport.update({
  id: '/days-off',
  path: '/days-off',
  getParentRoute: () => rootRouteImport,
} as any)
const CrmRoute = CrmRouteImport.update({
  id: '/crm',
  path: '/crm',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarRoute = CalendarRouteImport.update({
  id: '/calendar',
  path: '/calendar',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamIndexRoute = TeamIndexRouteImport.update({
  id: '/team/',
  path: '/team/',
  getParentRoute: () => rootRouteImport,
} as any)
const StandupsIndexRoute = StandupsIndexRouteImport.update({
  id: '/standups/',
  path: '/standups/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsIndexRoute = ProjectsIndexRouteImport.update({
  id: '/projects/',
  path: '/projects/',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationsIndexRoute = EvaluationsIndexRouteImport.update({
  id: '/evaluations/',
  path: '/evaluations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const StandupsNewRoute = StandupsNewRouteImport.update({
  id: '/standups/new',
  path: '/standups/new',
  getParentRoute: () => rootRouteImport,
} as any)
const StandupsStandupIdRoute = StandupsStandupIdRouteImport.update({
  id: '/standups/$standupId',
  path: '/standups/$standupId',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsNewRoute = ProjectsNewRouteImport.update({
  id: '/projects/new',
  path: '/projects/new',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationsQuestionnairesRoute =
  EvaluationsQuestionnairesRouteImport.update({
    id: '/evaluations/questionnaires',
    path: '/evaluations/questionnaires',
    getParentRoute: () => rootRouteImport,
  } as any)
const EvaluationsKpisRoute = EvaluationsKpisRouteImport.update({
  id: '/evaluations/kpis',
  path: '/evaluations/kpis',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationsHistoryRoute = EvaluationsHistoryRouteImport.update({
  id: '/evaluations/history',
  path: '/evaluations/history',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationsDashboardRoute = EvaluationsDashboardRouteImport.update({
  id: '/evaluations/dashboard',
  path: '/evaluations/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationsAssessmentsRoute = EvaluationsAssessmentsRouteImport.update({
  id: '/evaluations/assessments',
  path: '/evaluations/assessments',
  getParentRoute: () => rootRouteImport,
} as any)
const EvaluationsIdRoute = EvaluationsIdRouteImport.update({
  id: '/evaluations/$id',
  path: '/evaluations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsersRoute = AdminUsersRouteImport.update({
  id: '/users',
  path: '/users',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSyncRoute = AdminSyncRouteImport.update({
  id: '/sync',
  path: '/sync',
  getParentRoute: () => AdminRoute,
} as any)
const AdminQuestionnairesRoute = AdminQuestionnairesRouteImport.update({
  id: '/questionnaires',
  path: '/questionnaires',
  getParentRoute: () => AdminRoute,
} as any)
const AdminProjectCategoriesRoute = AdminProjectCategoriesRouteImport.update({
  id: '/project-categories',
  path: '/project-categories',
  getParentRoute: () => AdminRoute,
} as any)
const AdminKpiDefinitionsRoute = AdminKpiDefinitionsRouteImport.update({
  id: '/kpi-definitions',
  path: '/kpi-definitions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminGoogleCalendarSyncRoute = AdminGoogleCalendarSyncRouteImport.update({
  id: '/google-calendar-sync',
  path: '/google-calendar-sync',
  getParentRoute: () => AdminRoute,
} as any)
const AdminEvaluationsConfigRoute = AdminEvaluationsConfigRouteImport.update({
  id: '/evaluations-config',
  path: '/evaluations-config',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDaysOffRoute = AdminDaysOffRouteImport.update({
  id: '/days-off',
  path: '/days-off',
  getParentRoute: () => AdminRoute,
} as any)
const AdminClientsRoute = AdminClientsRouteImport.update({
  id: '/clients',
  path: '/clients',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCalendarEventsRoute = AdminCalendarEventsRouteImport.update({
  id: '/calendar-events',
  path: '/calendar-events',
  getParentRoute: () => AdminRoute,
} as any)
const AdminAssessmentsRoute = AdminAssessmentsRouteImport.update({
  id: '/assessments',
  path: '/assessments',
  getParentRoute: () => AdminRoute,
} as any)
const TeamUserIdIndexRoute = TeamUserIdIndexRouteImport.update({
  id: '/team/$userId/',
  path: '/team/$userId/',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdIndexRoute = ProjectsProjectIdIndexRouteImport.update({
  id: '/projects/$projectId/',
  path: '/projects/$projectId/',
  getParentRoute: () => rootRouteImport,
} as any)
const TeamUserIdTicketsRoute = TeamUserIdTicketsRouteImport.update({
  id: '/team/$userId/tickets',
  path: '/team/$userId/tickets',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdIssuesRoute = ProjectsProjectIdIssuesRouteImport.update({
  id: '/projects/$projectId/issues',
  path: '/projects/$projectId/issues',
  getParentRoute: () => rootRouteImport,
} as any)
const ProjectsProjectIdEvaluationsConfigRoute =
  ProjectsProjectIdEvaluationsConfigRouteImport.update({
    id: '/projects/$projectId/evaluations-config',
    path: '/projects/$projectId/evaluations-config',
    getParentRoute: () => rootRouteImport,
  } as any)
const ProjectsProjectIdEditRoute = ProjectsProjectIdEditRouteImport.update({
  id: '/projects/$projectId/edit',
  path: '/projects/$projectId/edit',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsEventIdSessionsRoute = EventsEventIdSessionsRouteImport.update({
  id: '/events/$eventId/sessions',
  path: '/events/$eventId/sessions',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/crm': typeof CrmRoute
  '/days-off': typeof DaysOffRoute
  '/sesiones': typeof SesionesRoute
  '/tickets': typeof TicketsRoute
  '/admin/assessments': typeof AdminAssessmentsRoute
  '/admin/calendar-events': typeof AdminCalendarEventsRoute
  '/admin/clients': typeof AdminClientsRoute
  '/admin/days-off': typeof AdminDaysOffRoute
  '/admin/evaluations-config': typeof AdminEvaluationsConfigRoute
  '/admin/google-calendar-sync': typeof AdminGoogleCalendarSyncRoute
  '/admin/kpi-definitions': typeof AdminKpiDefinitionsRoute
  '/admin/project-categories': typeof AdminProjectCategoriesRoute
  '/admin/questionnaires': typeof AdminQuestionnairesRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/users': typeof AdminUsersRoute
  '/evaluations/$id': typeof EvaluationsIdRoute
  '/evaluations/assessments': typeof EvaluationsAssessmentsRoute
  '/evaluations/dashboard': typeof EvaluationsDashboardRoute
  '/evaluations/history': typeof EvaluationsHistoryRoute
  '/evaluations/kpis': typeof EvaluationsKpisRoute
  '/evaluations/questionnaires': typeof EvaluationsQuestionnairesRoute
  '/projects/new': typeof ProjectsNewRoute
  '/standups/$standupId': typeof StandupsStandupIdRoute
  '/standups/new': typeof StandupsNewRoute
  '/admin/': typeof AdminIndexRoute
  '/evaluations/': typeof EvaluationsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/standups/': typeof StandupsIndexRoute
  '/team/': typeof TeamIndexRoute
  '/events/$eventId/sessions': typeof EventsEventIdSessionsRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/projects/$projectId/evaluations-config': typeof ProjectsProjectIdEvaluationsConfigRoute
  '/projects/$projectId/issues': typeof ProjectsProjectIdIssuesRoute
  '/team/$userId/tickets': typeof TeamUserIdTicketsRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/team/$userId/': typeof TeamUserIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/calendar': typeof CalendarRoute
  '/crm': typeof CrmRoute
  '/days-off': typeof DaysOffRoute
  '/sesiones': typeof SesionesRoute
  '/tickets': typeof TicketsRoute
  '/admin/assessments': typeof AdminAssessmentsRoute
  '/admin/calendar-events': typeof AdminCalendarEventsRoute
  '/admin/clients': typeof AdminClientsRoute
  '/admin/days-off': typeof AdminDaysOffRoute
  '/admin/evaluations-config': typeof AdminEvaluationsConfigRoute
  '/admin/google-calendar-sync': typeof AdminGoogleCalendarSyncRoute
  '/admin/kpi-definitions': typeof AdminKpiDefinitionsRoute
  '/admin/project-categories': typeof AdminProjectCategoriesRoute
  '/admin/questionnaires': typeof AdminQuestionnairesRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/users': typeof AdminUsersRoute
  '/evaluations/$id': typeof EvaluationsIdRoute
  '/evaluations/assessments': typeof EvaluationsAssessmentsRoute
  '/evaluations/dashboard': typeof EvaluationsDashboardRoute
  '/evaluations/history': typeof EvaluationsHistoryRoute
  '/evaluations/kpis': typeof EvaluationsKpisRoute
  '/evaluations/questionnaires': typeof EvaluationsQuestionnairesRoute
  '/projects/new': typeof ProjectsNewRoute
  '/standups/$standupId': typeof StandupsStandupIdRoute
  '/standups/new': typeof StandupsNewRoute
  '/admin': typeof AdminIndexRoute
  '/evaluations': typeof EvaluationsIndexRoute
  '/projects': typeof ProjectsIndexRoute
  '/standups': typeof StandupsIndexRoute
  '/team': typeof TeamIndexRoute
  '/events/$eventId/sessions': typeof EventsEventIdSessionsRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/projects/$projectId/evaluations-config': typeof ProjectsProjectIdEvaluationsConfigRoute
  '/projects/$projectId/issues': typeof ProjectsProjectIdIssuesRoute
  '/team/$userId/tickets': typeof TeamUserIdTicketsRoute
  '/projects/$projectId': typeof ProjectsProjectIdIndexRoute
  '/team/$userId': typeof TeamUserIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/admin': typeof AdminRouteWithChildren
  '/calendar': typeof CalendarRoute
  '/crm': typeof CrmRoute
  '/days-off': typeof DaysOffRoute
  '/sesiones': typeof SesionesRoute
  '/tickets': typeof TicketsRoute
  '/admin/assessments': typeof AdminAssessmentsRoute
  '/admin/calendar-events': typeof AdminCalendarEventsRoute
  '/admin/clients': typeof AdminClientsRoute
  '/admin/days-off': typeof AdminDaysOffRoute
  '/admin/evaluations-config': typeof AdminEvaluationsConfigRoute
  '/admin/google-calendar-sync': typeof AdminGoogleCalendarSyncRoute
  '/admin/kpi-definitions': typeof AdminKpiDefinitionsRoute
  '/admin/project-categories': typeof AdminProjectCategoriesRoute
  '/admin/questionnaires': typeof AdminQuestionnairesRoute
  '/admin/sync': typeof AdminSyncRoute
  '/admin/users': typeof AdminUsersRoute
  '/evaluations/$id': typeof EvaluationsIdRoute
  '/evaluations/assessments': typeof EvaluationsAssessmentsRoute
  '/evaluations/dashboard': typeof EvaluationsDashboardRoute
  '/evaluations/history': typeof EvaluationsHistoryRoute
  '/evaluations/kpis': typeof EvaluationsKpisRoute
  '/evaluations/questionnaires': typeof EvaluationsQuestionnairesRoute
  '/projects/new': typeof ProjectsNewRoute
  '/standups/$standupId': typeof StandupsStandupIdRoute
  '/standups/new': typeof StandupsNewRoute
  '/admin/': typeof AdminIndexRoute
  '/evaluations/': typeof EvaluationsIndexRoute
  '/projects/': typeof ProjectsIndexRoute
  '/standups/': typeof StandupsIndexRoute
  '/team/': typeof TeamIndexRoute
  '/events/$eventId/sessions': typeof EventsEventIdSessionsRoute
  '/projects/$projectId/edit': typeof ProjectsProjectIdEditRoute
  '/projects/$projectId/evaluations-config': typeof ProjectsProjectIdEvaluationsConfigRoute
  '/projects/$projectId/issues': typeof ProjectsProjectIdIssuesRoute
  '/team/$userId/tickets': typeof TeamUserIdTicketsRoute
  '/projects/$projectId/': typeof ProjectsProjectIdIndexRoute
  '/team/$userId/': typeof TeamUserIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/admin'
    | '/calendar'
    | '/crm'
    | '/days-off'
    | '/sesiones'
    | '/tickets'
    | '/admin/assessments'
    | '/admin/calendar-events'
    | '/admin/clients'
    | '/admin/days-off'
    | '/admin/evaluations-config'
    | '/admin/google-calendar-sync'
    | '/admin/kpi-definitions'
    | '/admin/project-categories'
    | '/admin/questionnaires'
    | '/admin/sync'
    | '/admin/users'
    | '/evaluations/$id'
    | '/evaluations/assessments'
    | '/evaluations/dashboard'
    | '/evaluations/history'
    | '/evaluations/kpis'
    | '/evaluations/questionnaires'
    | '/projects/new'
    | '/standups/$standupId'
    | '/standups/new'
    | '/admin/'
    | '/evaluations/'
    | '/projects/'
    | '/standups/'
    | '/team/'
    | '/events/$eventId/sessions'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/evaluations-config'
    | '/projects/$projectId/issues'
    | '/team/$userId/tickets'
    | '/projects/$projectId/'
    | '/team/$userId/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/calendar'
    | '/crm'
    | '/days-off'
    | '/sesiones'
    | '/tickets'
    | '/admin/assessments'
    | '/admin/calendar-events'
    | '/admin/clients'
    | '/admin/days-off'
    | '/admin/evaluations-config'
    | '/admin/google-calendar-sync'
    | '/admin/kpi-definitions'
    | '/admin/project-categories'
    | '/admin/questionnaires'
    | '/admin/sync'
    | '/admin/users'
    | '/evaluations/$id'
    | '/evaluations/assessments'
    | '/evaluations/dashboard'
    | '/evaluations/history'
    | '/evaluations/kpis'
    | '/evaluations/questionnaires'
    | '/projects/new'
    | '/standups/$standupId'
    | '/standups/new'
    | '/admin'
    | '/evaluations'
    | '/projects'
    | '/standups'
    | '/team'
    | '/events/$eventId/sessions'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/evaluations-config'
    | '/projects/$projectId/issues'
    | '/team/$userId/tickets'
    | '/projects/$projectId'
    | '/team/$userId'
  id:
    | '__root__'
    | '/'
    | '/admin'
    | '/calendar'
    | '/crm'
    | '/days-off'
    | '/sesiones'
    | '/tickets'
    | '/admin/assessments'
    | '/admin/calendar-events'
    | '/admin/clients'
    | '/admin/days-off'
    | '/admin/evaluations-config'
    | '/admin/google-calendar-sync'
    | '/admin/kpi-definitions'
    | '/admin/project-categories'
    | '/admin/questionnaires'
    | '/admin/sync'
    | '/admin/users'
    | '/evaluations/$id'
    | '/evaluations/assessments'
    | '/evaluations/dashboard'
    | '/evaluations/history'
    | '/evaluations/kpis'
    | '/evaluations/questionnaires'
    | '/projects/new'
    | '/standups/$standupId'
    | '/standups/new'
    | '/admin/'
    | '/evaluations/'
    | '/projects/'
    | '/standups/'
    | '/team/'
    | '/events/$eventId/sessions'
    | '/projects/$projectId/edit'
    | '/projects/$projectId/evaluations-config'
    | '/projects/$projectId/issues'
    | '/team/$userId/tickets'
    | '/projects/$projectId/'
    | '/team/$userId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AdminRoute: typeof AdminRouteWithChildren
  CalendarRoute: typeof CalendarRoute
  CrmRoute: typeof CrmRoute
  DaysOffRoute: typeof DaysOffRoute
  SesionesRoute: typeof SesionesRoute
  TicketsRoute: typeof TicketsRoute
  EvaluationsIdRoute: typeof EvaluationsIdRoute
  EvaluationsAssessmentsRoute: typeof EvaluationsAssessmentsRoute
  EvaluationsDashboardRoute: typeof EvaluationsDashboardRoute
  EvaluationsHistoryRoute: typeof EvaluationsHistoryRoute
  EvaluationsKpisRoute: typeof EvaluationsKpisRoute
  EvaluationsQuestionnairesRoute: typeof EvaluationsQuestionnairesRoute
  ProjectsNewRoute: typeof ProjectsNewRoute
  StandupsStandupIdRoute: typeof StandupsStandupIdRoute
  StandupsNewRoute: typeof StandupsNewRoute
  EvaluationsIndexRoute: typeof EvaluationsIndexRoute
  ProjectsIndexRoute: typeof ProjectsIndexRoute
  StandupsIndexRoute: typeof StandupsIndexRoute
  TeamIndexRoute: typeof TeamIndexRoute
  EventsEventIdSessionsRoute: typeof EventsEventIdSessionsRoute
  ProjectsProjectIdEditRoute: typeof ProjectsProjectIdEditRoute
  ProjectsProjectIdEvaluationsConfigRoute: typeof ProjectsProjectIdEvaluationsConfigRoute
  ProjectsProjectIdIssuesRoute: typeof ProjectsProjectIdIssuesRoute
  TeamUserIdTicketsRoute: typeof TeamUserIdTicketsRoute
  ProjectsProjectIdIndexRoute: typeof ProjectsProjectIdIndexRoute
  TeamUserIdIndexRoute: typeof TeamUserIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tickets': {
      id: '/tickets'
      path: '/tickets'
      fullPath: '/tickets'
      preLoaderRoute: typeof TicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/sesiones': {
      id: '/sesiones'
      path: '/sesiones'
      fullPath: '/sesiones'
      preLoaderRoute: typeof SesionesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/days-off': {
      id: '/days-off'
      path: '/days-off'
      fullPath: '/days-off'
      preLoaderRoute: typeof DaysOffRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/crm': {
      id: '/crm'
      path: '/crm'
      fullPath: '/crm'
      preLoaderRoute: typeof CrmRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar': {
      id: '/calendar'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/': {
      id: '/team/'
      path: '/team'
      fullPath: '/team/'
      preLoaderRoute: typeof TeamIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/standups/': {
      id: '/standups/'
      path: '/standups'
      fullPath: '/standups/'
      preLoaderRoute: typeof StandupsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/': {
      id: '/projects/'
      path: '/projects'
      fullPath: '/projects/'
      preLoaderRoute: typeof ProjectsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluations/': {
      id: '/evaluations/'
      path: '/evaluations'
      fullPath: '/evaluations/'
      preLoaderRoute: typeof EvaluationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/standups/new': {
      id: '/standups/new'
      path: '/standups/new'
      fullPath: '/standups/new'
      preLoaderRoute: typeof StandupsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/standups/$standupId': {
      id: '/standups/$standupId'
      path: '/standups/$standupId'
      fullPath: '/standups/$standupId'
      preLoaderRoute: typeof StandupsStandupIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/new': {
      id: '/projects/new'
      path: '/projects/new'
      fullPath: '/projects/new'
      preLoaderRoute: typeof ProjectsNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluations/questionnaires': {
      id: '/evaluations/questionnaires'
      path: '/evaluations/questionnaires'
      fullPath: '/evaluations/questionnaires'
      preLoaderRoute: typeof EvaluationsQuestionnairesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluations/kpis': {
      id: '/evaluations/kpis'
      path: '/evaluations/kpis'
      fullPath: '/evaluations/kpis'
      preLoaderRoute: typeof EvaluationsKpisRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluations/history': {
      id: '/evaluations/history'
      path: '/evaluations/history'
      fullPath: '/evaluations/history'
      preLoaderRoute: typeof EvaluationsHistoryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluations/dashboard': {
      id: '/evaluations/dashboard'
      path: '/evaluations/dashboard'
      fullPath: '/evaluations/dashboard'
      preLoaderRoute: typeof EvaluationsDashboardRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluations/assessments': {
      id: '/evaluations/assessments'
      path: '/evaluations/assessments'
      fullPath: '/evaluations/assessments'
      preLoaderRoute: typeof EvaluationsAssessmentsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/evaluations/$id': {
      id: '/evaluations/$id'
      path: '/evaluations/$id'
      fullPath: '/evaluations/$id'
      preLoaderRoute: typeof EvaluationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/users': {
      id: '/admin/users'
      path: '/users'
      fullPath: '/admin/users'
      preLoaderRoute: typeof AdminUsersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/sync': {
      id: '/admin/sync'
      path: '/sync'
      fullPath: '/admin/sync'
      preLoaderRoute: typeof AdminSyncRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/questionnaires': {
      id: '/admin/questionnaires'
      path: '/questionnaires'
      fullPath: '/admin/questionnaires'
      preLoaderRoute: typeof AdminQuestionnairesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/project-categories': {
      id: '/admin/project-categories'
      path: '/project-categories'
      fullPath: '/admin/project-categories'
      preLoaderRoute: typeof AdminProjectCategoriesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/kpi-definitions': {
      id: '/admin/kpi-definitions'
      path: '/kpi-definitions'
      fullPath: '/admin/kpi-definitions'
      preLoaderRoute: typeof AdminKpiDefinitionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/google-calendar-sync': {
      id: '/admin/google-calendar-sync'
      path: '/google-calendar-sync'
      fullPath: '/admin/google-calendar-sync'
      preLoaderRoute: typeof AdminGoogleCalendarSyncRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/evaluations-config': {
      id: '/admin/evaluations-config'
      path: '/evaluations-config'
      fullPath: '/admin/evaluations-config'
      preLoaderRoute: typeof AdminEvaluationsConfigRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/days-off': {
      id: '/admin/days-off'
      path: '/days-off'
      fullPath: '/admin/days-off'
      preLoaderRoute: typeof AdminDaysOffRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/clients': {
      id: '/admin/clients'
      path: '/clients'
      fullPath: '/admin/clients'
      preLoaderRoute: typeof AdminClientsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/calendar-events': {
      id: '/admin/calendar-events'
      path: '/calendar-events'
      fullPath: '/admin/calendar-events'
      preLoaderRoute: typeof AdminCalendarEventsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/assessments': {
      id: '/admin/assessments'
      path: '/assessments'
      fullPath: '/admin/assessments'
      preLoaderRoute: typeof AdminAssessmentsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/team/$userId/': {
      id: '/team/$userId/'
      path: '/team/$userId'
      fullPath: '/team/$userId/'
      preLoaderRoute: typeof TeamUserIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/': {
      id: '/projects/$projectId/'
      path: '/projects/$projectId'
      fullPath: '/projects/$projectId/'
      preLoaderRoute: typeof ProjectsProjectIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/team/$userId/tickets': {
      id: '/team/$userId/tickets'
      path: '/team/$userId/tickets'
      fullPath: '/team/$userId/tickets'
      preLoaderRoute: typeof TeamUserIdTicketsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/issues': {
      id: '/projects/$projectId/issues'
      path: '/projects/$projectId/issues'
      fullPath: '/projects/$projectId/issues'
      preLoaderRoute: typeof ProjectsProjectIdIssuesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/evaluations-config': {
      id: '/projects/$projectId/evaluations-config'
      path: '/projects/$projectId/evaluations-config'
      fullPath: '/projects/$projectId/evaluations-config'
      preLoaderRoute: typeof ProjectsProjectIdEvaluationsConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/projects/$projectId/edit': {
      id: '/projects/$projectId/edit'
      path: '/projects/$projectId/edit'
      fullPath: '/projects/$projectId/edit'
      preLoaderRoute: typeof ProjectsProjectIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events/$eventId/sessions': {
      id: '/events/$eventId/sessions'
      path: '/events/$eventId/sessions'
      fullPath: '/events/$eventId/sessions'
      preLoaderRoute: typeof EventsEventIdSessionsRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteChildren {
  AdminAssessmentsRoute: typeof AdminAssessmentsRoute
  AdminCalendarEventsRoute: typeof AdminCalendarEventsRoute
  AdminClientsRoute: typeof AdminClientsRoute
  AdminDaysOffRoute: typeof AdminDaysOffRoute
  AdminEvaluationsConfigRoute: typeof AdminEvaluationsConfigRoute
  AdminGoogleCalendarSyncRoute: typeof AdminGoogleCalendarSyncRoute
  AdminKpiDefinitionsRoute: typeof AdminKpiDefinitionsRoute
  AdminProjectCategoriesRoute: typeof AdminProjectCategoriesRoute
  AdminQuestionnairesRoute: typeof AdminQuestionnairesRoute
  AdminSyncRoute: typeof AdminSyncRoute
  AdminUsersRoute: typeof AdminUsersRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminAssessmentsRoute: AdminAssessmentsRoute,
  AdminCalendarEventsRoute: AdminCalendarEventsRoute,
  AdminClientsRoute: AdminClientsRoute,
  AdminDaysOffRoute: AdminDaysOffRoute,
  AdminEvaluationsConfigRoute: AdminEvaluationsConfigRoute,
  AdminGoogleCalendarSyncRoute: AdminGoogleCalendarSyncRoute,
  AdminKpiDefinitionsRoute: AdminKpiDefinitionsRoute,
  AdminProjectCategoriesRoute: AdminProjectCategoriesRoute,
  AdminQuestionnairesRoute: AdminQuestionnairesRoute,
  AdminSyncRoute: AdminSyncRoute,
  AdminUsersRoute: AdminUsersRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AdminRoute: AdminRouteWithChildren,
  CalendarRoute: CalendarRoute,
  CrmRoute: CrmRoute,
  DaysOffRoute: DaysOffRoute,
  SesionesRoute: SesionesRoute,
  TicketsRoute: TicketsRoute,
  EvaluationsIdRoute: EvaluationsIdRoute,
  EvaluationsAssessmentsRoute: EvaluationsAssessmentsRoute,
  EvaluationsDashboardRoute: EvaluationsDashboardRoute,
  EvaluationsHistoryRoute: EvaluationsHistoryRoute,
  EvaluationsKpisRoute: EvaluationsKpisRoute,
  EvaluationsQuestionnairesRoute: EvaluationsQuestionnairesRoute,
  ProjectsNewRoute: ProjectsNewRoute,
  StandupsStandupIdRoute: StandupsStandupIdRoute,
  StandupsNewRoute: StandupsNewRoute,
  EvaluationsIndexRoute: EvaluationsIndexRoute,
  ProjectsIndexRoute: ProjectsIndexRoute,
  StandupsIndexRoute: StandupsIndexRoute,
  TeamIndexRoute: TeamIndexRoute,
  EventsEventIdSessionsRoute: EventsEventIdSessionsRoute,
  ProjectsProjectIdEditRoute: ProjectsProjectIdEditRoute,
  ProjectsProjectIdEvaluationsConfigRoute:
    ProjectsProjectIdEvaluationsConfigRoute,
  ProjectsProjectIdIssuesRoute: ProjectsProjectIdIssuesRoute,
  TeamUserIdTicketsRoute: TeamUserIdTicketsRoute,
  ProjectsProjectIdIndexRoute: ProjectsProjectIdIndexRoute,
  TeamUserIdIndexRoute: TeamUserIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
